module.exports = __webpack_public_path__ + "static/media/finneoColliersTechstars2.acdd70a7.png";